import { logAppError } from "Helpers/logger";
import type { CallbackInterface } from "recoil";

import type { PageStateType } from "Types/state";

import { errorUpdater, loaderUpdater, pageState } from "State/page";

import { fetchDefaultConfirmationMesssage } from "Pages/RecipientsList/recoil/services/asyncSelectConfirmationMessages";
import { sendConfirmationEmail } from "Pages/RecipientsList/recoil/services/modalSendConfirmation";
import { modalSendConfirmationState } from "Pages/RecipientsList/recoil/state/modalSendConfirmation";
import { panelEditRecipientState } from "Pages/RecipientsList/recoil/state/recipient";

import { notifySendConfirmationSuccess } from "Pages/RecipientsList/recoil/services/notifications";

import { reloadRecipientCallback } from "Pages/RecipientsList/recoil/callbacks/recipient";

export const modalSendConfirmationOpenCallback =
  ({ set, snapshot }: CallbackInterface) =>
  async () => {
    const { recipient } = await snapshot.getPromise(panelEditRecipientState);

    if (
      recipient !== undefined &&
      recipient.EmailSubscriptionStatus === "PENDING"
    ) {
      set<PageStateType>(pageState, loaderUpdater(true));

      try {
        const idConfirmationMessage = await fetchDefaultConfirmationMesssage();

        set(modalSendConfirmationState, (prev) => ({
          ...prev,
          show: true,
          idRecipient: recipient.Id,
          contact: recipient.Email,
          idConfirmationMessage,
        }));
      } catch (error) {
        logAppError({
          Component: "RecipientsList",
          Method: "modalSendConfirmationOpenCallback",
          appError: error,
        });

        set<PageStateType>(pageState, errorUpdater);
      }

      set<PageStateType>(pageState, loaderUpdater(false));
    }
  };

export const modalSendConfirmationCancelCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalSendConfirmationState);
  };

export const modalSendConfirmationChangeMessageCallback =
  ({ set }: CallbackInterface) =>
  async (idConfirmationMessage: number) => {
    set(modalSendConfirmationState, (prev) => ({
      ...prev,
      idConfirmationMessage,
      idConfirmationMessageIsDirty: true,
    }));
  };

export const modalSendConfirmationConfirmCallback =
  ({ set, snapshot, reset, ...cbi }: CallbackInterface) =>
  async (_sendConfirmationMessage: boolean) => {
    set<PageStateType>(pageState, loaderUpdater(true));

    const { idRecipient, idConfirmationMessage, contact } =
      await snapshot.getPromise(modalSendConfirmationState);

    try {
      //  send confirmation email

      await sendConfirmationEmail(idRecipient, idConfirmationMessage);

      await reloadRecipientCallback({ set, snapshot, reset, ...cbi })(
        idRecipient,
      );

      //  notify success
      notifySendConfirmationSuccess(contact);
    } catch (error) {
      logAppError({
        Component: "RecipientsList",
        Method: "modalSendConfirmationConfirmCallback",
        appError: error,
      });

      set<PageStateType>(pageState, errorUpdater);
    }

    reset(modalSendConfirmationState);

    set<PageStateType>(pageState, loaderUpdater(false));
  };
